import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const PspRedirectGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  /* step 1: Are they authenticated? */
  let isAuthenticated = (!authService.setUser() && !authService.getUser()) ? false : true;

  if(isAuthenticated){
    const roles = authService.getRoles();
    const isAuthenticated: boolean = roles !== null && roles.length > 0;
    const hasAgreedToTerms = authService.getHasAgreedToTerms();
    const isCsr = roles && roles.includes('csr_user');
    const isMc = roles && roles.includes('mc_view');
    const isTpip = roles && roles.includes('mc_request') && !roles.includes('mc_view');
    const isDriver = roles && roles.includes('driver');

    // check if user has role for dashboard
    if (!isMc) { //drivers are not MC so we should hit this
      if (!hasAgreedToTerms) {// drivers we should pick up they have agreed in from the auth service
        if (isTpip) { 
          authService.setAccountType('tpip'); 
        }else if (isDriver) {
          authService.setAccountType('oa');
        }
        // user has not agreed to terms and conditions
        return inject(Router).navigate(['/termsandconditions']);
      }else if (window.location.href.includes('redirectUrl=')) {
        // if the user has agreed to terms and 
        // there is a redirectUrl query param
        return true;
      } else {
          /* step 3: the user is authorized and has agreed to terms */
          // not authorized
          return inject(Router).navigate(['/accessDenied']);
      }
    } else {
      authService.setAccountType('mah');
      /* step 2: Has the user agreed to the terms and conditions? */
      if (!hasAgreedToTerms) {
          // user has not agreed to terms and conditions
          return inject(Router).navigate(['/termsandconditions']);
      } else {
          /* step 3: the user is authorized and has agreed to terms */
          // Look for audit acknowledgement conditions
          return true;
      }
    }
  } else {
        /* step 1b: Is the user in an authorized role to see the given page? */
          // not logged in so redirect to login page with the DEEPLINK as return url
    if (window.location.href.includes('/byAuthCode/')) {
      const currentUrl = window.location.href.replace('/psp', '');
      authService.setDeepLink(currentUrl);
      return inject(Router).navigate(['/signin']);
    } else {
      authService.setDeepLink('');
    }
    // Preserve query string when redirecting to home
    const queryParams = state.root.queryParams;
    return inject(Router).createUrlTree(['home'], { queryParams });
  }
};
